





























































































import Vue from "vue";
import Component from "vue-class-component";
import authService from "../../features/api-authorization/authorize-service";
import naturezaJuridicaService from "../natureza-juridica/natureza-juridica-service";
import usuarioService from "../usuario/usuario-service";
import Api from "../../base/api.typings";
import empresaAtualService from "./empresa-atual-service";
import areaService from "../area-atual/area-service";
import routerService from '../../base/router-service';
import licencaService from '../licenca/licenca-service';

@Component
export default class EmpresaAtualListar extends Vue {
    empresas: Api.App.Server.Usuario.ListarEmpresas.EmpresaDto[] = [];

    empresaAtual: string = null;

    dialog: boolean = true;

    licencas: number = 0;

    user;

    async obterEmpresaAtual() {
        this.empresaAtual = await empresaAtualService.obterEmpresaAtualId();
    }

    async listarEmpresaUsuario() {
        let itens = await usuarioService.listarEmpresas({});

        if (itens.empresas.length == 1) {
            this.inserirEmpresaAtualId(itens.empresas[0].id);
        }

        if (this.naturezaJuridica && this.regimeTributario) {
            this.empresas = itens.empresas.filter(p =>
                p.naturezaJuridicaId == this.naturezaJuridica.id &&
                p.regimeTributario == this.regimeTributario);
        } else if (this.naturezaJuridica) {
            this.empresas = itens.empresas.filter(p => p.naturezaJuridicaId == this.naturezaJuridica.id);
        } else if (this.regimeTributario) {
            this.empresas = itens.empresas.filter(p => p.regimeTributario == this.regimeTributario);
        } else {
            this.empresas = itens.empresas;
        }            
    }

    regimeTributario: Api.Common.Domain.RegimeTributarioEnum = null;
    naturezaJuridica: Api.App.Server.NaturezaJuridica.Listar.NaturezaJuridicaDto = null;

    totalEmpresas: number = null;

    get carregando() {
        this.totalEmpresas = this.empresas.length;
        return !this.empresas;
    }

    async voltar() {
        if (this.empresaAtual)
            await routerService.goTo('painel-empresa');
        else
            await routerService.goTo('painel');
    }

    naturezas: Api.App.Server.NaturezaJuridica.Listar.NaturezaJuridicaDto[] = [];
    regimes = [
        { value: Api.Common.Domain.RegimeTributarioEnum.SimplesNacional, text: 'Simples Nacional' },
        { value: Api.Common.Domain.RegimeTributarioEnum.LucroPresumido, text: 'Lucro Presumido' },
        { value: Api.Common.Domain.RegimeTributarioEnum.LucroReal, text: 'Lucro Real' }
    ];

    obterRegimeDescricao(value: number) {
        let regime = this.regimes.find(p => p.value == value);
        if (regime) {
            return regime.text;
        }
    }

    private async listar() {
        let resultado = await naturezaJuridicaService.listar({});
        this.naturezas = resultado.itens;

        const licenca = await licencaService.listar({
            usuarioId: this.user.sub,
            telaInicial: true
        });

        this.licencas = licenca.totalItens;

        if (this.licencas == 0 && (this.user.perfil == Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Cliente || this.user.perfil == Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Contador)) {
            window.location.replace("http://contou.com.br/carrinho")
        }
    }

    usuarioNome: string = null;

    async carregarDadosUsuario() {
        let user = await authService.getUser();

        if (!user)
            return;

        this.usuarioNome = user.preferred_username.split(' ').length > 0 ? user.preferred_username.split(' ')[0] : user.preferred_username;
    }

    async created() {
        let usuario = await authService.getUser();
        this.user = usuario;
        this.obterEmpresaAtual();
        this.listar();
        await this.carregarDadosUsuario();
        this.listarEmpresaUsuario();
    }

    mounted() {

    }

    beforeRouteUpdate() {
        this.listar();
        this.listarEmpresaUsuario();
    }

    async inserirEmpresaAtualId(empresaId: string) {
        await empresaAtualService.inserirEmpresaAtualId(empresaId);

        let user = await authService.getUser();

        if (!user)
            return;

        if (user.perfil == 2) {
            await areaService.setarArea("usuario");
            await routerService.goTo('funcionario-cadastrar-selecao');
        } else {
            await areaService.setarArea("empresa");
            await routerService.goTo('painel-empresa');
        }
        window.location.reload();
    }
}
